module.exports = __webpack_public_path__ + "img/pd-img10.be80d78c.png";